import { render } from "./titlePage.vue?vue&type=template&id=97c6b97c&scoped=true"
import script from "./titlePage.vue?vue&type=script&lang=js"
export * from "./titlePage.vue?vue&type=script&lang=js"

import "./titlePage.vue?vue&type=style&index=0&id=97c6b97c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97c6b97c"]])

export default __exports__